/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ action: NonNullable<unknown>, rate: NonNullable<unknown> }} Seo_Price_PhraseInputs */

const en_seo_price_phrase = /** @type {(inputs: Seo_Price_PhraseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.action} ${i?.rate}`)
};

const zh_hans1_seo_price_phrase = /** @type {(inputs: Seo_Price_PhraseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.action}，${i?.rate}`)
};

const pt_br2_seo_price_phrase = /** @type {(inputs: Seo_Price_PhraseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.action} ${i?.rate}`)
};

const es_seo_price_phrase = /** @type {(inputs: Seo_Price_PhraseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.action} ${i?.rate}`)
};

const fr_seo_price_phrase = /** @type {(inputs: Seo_Price_PhraseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.action} ${i?.rate}`)
};

const de_seo_price_phrase = /** @type {(inputs: Seo_Price_PhraseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.action} ${i?.rate}`)
};

const ru_seo_price_phrase = /** @type {(inputs: Seo_Price_PhraseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.action} ${i?.rate}`)
};

const it_seo_price_phrase = /** @type {(inputs: Seo_Price_PhraseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.action} ${i?.rate}`)
};

/**
* | output |
* | --- |
* | "{action} {rate}" |
*
* @param {Seo_Price_PhraseInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const seo_price_phrase = /** @type {((inputs: Seo_Price_PhraseInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Price_PhraseInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_seo_price_phrase(inputs)
	if (locale === "pt-BR") return pt_br2_seo_price_phrase(inputs)
	if (locale === "es") return es_seo_price_phrase(inputs)
	if (locale === "fr") return fr_seo_price_phrase(inputs)
	if (locale === "de") return de_seo_price_phrase(inputs)
	if (locale === "ru") return ru_seo_price_phrase(inputs)
	if (locale === "it") return it_seo_price_phrase(inputs)
	return en_seo_price_phrase(inputs)
});